"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _DataDisplayWidget = _interopRequireDefault(require("./Style/DataDisplayWidget"));

var _axios = _interopRequireDefault(require("axios"));

var _config = _interopRequireDefault(require("../../../../config.json"));

var _utils = _interopRequireDefault(require("../../../../utils"));

var _errorPage = _interopRequireDefault(require("../../../error-views/errorPage"));

// import { useHistory } from 'react-router';
var panelIndex = -1;
var option = '';
var data = [];
var allData = [];
var saveData = {};
var responseData = [];
var Option = _antd.Select.Option;

var EnglishData = function EnglishData(_ref) {
  var parentdata1 = _ref.parentdata1,
      RMCode = _ref.RMCode,
      onChangeHeading = _ref.onChangeHeading;
  // const history = useHistory();
  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token"); // eslint-disable-next-line

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      tableData = _useState2[0],
      setTableData = _useState2[1]; // eslint-disable-next-line


  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      alltableData = _useState4[0],
      setallTableData = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      filledData = _useState6[0],
      setFilledData = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      warningBack = _useState8[0],
      setwarningBack = _useState8[1];

  var _useState9 = (0, _react.useState)(true),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      loading = _useState10[0],
      setLoading = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      apiError = _useState12[0],
      setapiError = _useState12[1];

  var date = new Date();
  var year = date.getFullYear();
  var month = ("0" + (date.getMonth() + 1)).slice(-2);
  var day = ("0" + date.getDate()).slice(-2);
  var today_Date = "".concat(year, "-").concat(month, "-").concat(day); // useEffect(async () => {
  //   let url = config.getRMEngAudit+cl+'&RMcode='+RMCode +'&date='+ today_Date;    
  //   await axios.get(url,{ headers: { 'Authorization': token } })
  //  .then(resp=>{
  //    if (resp.data.status === "error") setapiError(resp.data);
  //    else{
  //     //  console.log(resp);
  //      responseData=resp.data;
  //    }
  //  },error=>{
  //    setapiError(error.response);
  //  }) 
  //   if (parentdata1.length > 0) {
  //     let parentAuditdata = parentdata1.map(item => (
  //       {
  //         'Token_no': item.Token_no,
  //         'Student_name': item.Student_name,
  //         'Label': item.Label,
  //         'Marks': item.Marks,
  //         'Worksheet_link': item.Worksheet_link,
  //         'sendSheet': '',
  //         'sendMarks': '',
  //         'sendCorrectMarks': ''
  //       }
  //     ))
  //     parentAuditdata.map((o1)=>{
  //       let obj=responseData.find((o2)=>o2.Token_no===o1.Token_no)
  //       console.log(obj)
  //       if(obj)
  //       {
  //       o1.sendSheet=obj.send_sheets;
  //       o1.sendMarks=obj.RM_Send_mark_in_evening;
  //       o1.sendCorrectMarks= obj.RM_give_correct_marks;
  //       }
  //     })
  //     setTableData(parentAuditdata);
  //     setallTableData(parentAuditdata);
  //     data = parentAuditdata;
  //     allData = parentAuditdata;
  //     setLoading(false)
  //   }
  //   let filterData = allData.filter(item => item.sendSheet !== '' && item.sendMarks !== '' && item.sendCorrectMarks !== '')
  //   setFilledData(filterData.length)
  // }, [parentdata1]);

  (0, _react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var url, parentAuditdata, filterData;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = _config.default.getRMEngAudit + cl + '&RMcode=' + RMCode + '&date=' + today_Date;
                _context.next = 3;
                return _axios.default.get(url, {
                  headers: {
                    'Authorization': token
                  }
                }).then(function (resp) {
                  if (resp.data.status === "error") setapiError(resp.data);else {
                    //  console.log(resp);
                    responseData = resp.data;
                  }
                }, function (error) {
                  setapiError(error.response);
                });

              case 3:
                if (parentdata1.length > 0) {
                  parentAuditdata = parentdata1.map(function (item) {
                    return {
                      'Token_no': item.Token_no,
                      'Student_name': item.Student_name,
                      'Label': item.Label,
                      'Marks': item.Marks,
                      'Worksheet_link': item.Worksheet_link,
                      'sendSheet': '',
                      'sendMarks': '',
                      'sendCorrectMarks': ''
                    };
                  });
                  parentAuditdata.forEach(function (o1) {
                    var obj = responseData.find(function (o2) {
                      return o2.Token_no === o1.Token_no;
                    });
                    console.log(obj);

                    if (obj) {
                      o1.sendSheet = obj.send_sheets;
                      o1.sendMarks = obj.RM_Send_mark_in_evening;
                      o1.sendCorrectMarks = obj.RM_give_correct_marks;
                    }
                  });
                  setTableData(parentAuditdata);
                  setallTableData(parentAuditdata);
                  data = parentAuditdata;
                  allData = parentAuditdata;
                  setLoading(false);
                }

                filterData = allData.filter(function (item) {
                  return item.sendSheet !== '' && item.sendMarks !== '' && item.sendCorrectMarks !== '';
                });
                setFilledData(filterData.length);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData(); // eslint-disable-next-line 
  }, [parentdata1]);

  function panelChange(value, str) {
    var index = allData.findIndex(function (i) {
      return i.Token_no === value.Token_no;
    });
    panelIndex = index;
    option = str;
  }

  var selectOption = function selectOption(e) {
    if (option === "sendSheet") {
      //  data[panelIndex].sendSheet=e.target.value;
      allData[panelIndex].sendSheet = e;
      setTableData(allData);
    } else if (option === "sendMarks") {
      //  data[panelIndex].sendMarks=e.target.value;
      allData[panelIndex].sendMarks = e;
      setTableData(allData);
    } else if (option === "sendCorrectMarks") {
      //  data[panelIndex].sendCorrectMarks=e.target.value;
      allData[panelIndex].sendCorrectMarks = e;
      setTableData(allData);
    }

    var filterData = allData.filter(function (item) {
      return item.sendSheet !== '' && item.sendMarks !== '' && item.sendCorrectMarks !== '';
    });
    setFilledData(filterData.length);

    if (allData[panelIndex].sendSheet !== '' && allData[panelIndex].sendMarks !== '' && allData[panelIndex].sendCorrectMarks !== '') {
      saveData = allData[panelIndex];
      saveAudit();
    }
  };

  var saveAudit = function saveAudit() {
    var url1 = _config.default.postRMAuditEngresponse + cl + '&RMcode=' + RMCode;

    _axios.default.post(url1, {
      rmData: [saveData]
    }).then(function (resp) {
      if (resp.data.status === "error") setapiError(resp.data);
    }, function (error) {
      setapiError(error.response);
    });
  };

  var submitAllParent = function submitAllParent() {
    if (allData.length > 40) {
      if (filledData >= 40) {
        submitAudit();
      } else {
        alert("".concat(filledData, " Student Data Filled. Please Fill atleaast 40 Student Data."));
      }
    } else {
      if (filledData === allData.length) {
        submitAudit();
      } else {
        alert("".concat(filledData, " Student Data Filled. Please Fill atleaast all Student Data."));
      }
    }
  };

  function submitAudit() {
    // let url1 = config.postRMAuditEngresponse + cl + '&RMcode=' + RMCode;
    var url2 = _config.default.postAuditRMEngScore + cl + '&RMcode=' + RMCode;
    var finalFmAuditScore = rmAuditScoreCalc(); // let filterData = allData.filter(item => item.sendSheet !== '' && item.sendMarks !== '' && item.sendCorrectMarks !== '')
    // axios.post(url1, { rmData: filterData })
    //   .then(resp => {
    //     if (resp.data.status == "error") setapiError(resp.data);
    //   }, error => {
    //     setapiError(error.response);
    //   })

    _axios.default.post(url2, {
      finalFmAuditScore: finalFmAuditScore
    }).then(function (resp) {
      if (resp.data.status === "error") setapiError(resp.data);
      alert("Today's RM Audit done Successfully!");
      window.location = '/clPortal/app/rm/audit';
    }, function (error) {
      setapiError(error.response);
    });
  }

  var rmAuditScoreCalc = function rmAuditScoreCalc() {
    var filterData = allData.filter(function (item) {
      return item.sendSheet !== '' && item.sendMarks !== '' && item.sendCorrectMarks !== '';
    });
    var positiveScore = filterData.length * 3;
    var negativeScore = allData.reduce(function (acc, cur) {
      if (cur.sendSheet === 'नहीं') ++acc;
      if (cur.sendMarks === 'नहीं') ++acc;
      if (cur.sendCorrectMarks === 'नहीं') ++acc;
      return acc;
    }, 0);
    var rmAuditScore = (positiveScore - negativeScore) / positiveScore * 100;
    return Math.round(rmAuditScore, 2);
  };

  var back = function back() {
    setwarningBack(!warningBack);
  };

  function cancel(e) {
    setwarningBack(false);
    onChangeHeading();
    window.location = _config.default.getAuditBackButtonLink;
  }

  var onSearch = function onSearch(e) {
    var value = e.currentTarget.value;

    var searchdata = _utils.default.wildCardSearch(allData, value);

    data = searchdata;
    setTableData(searchdata);
  };

  var FilterData = function FilterData(value) {
    if (value === 'Yes') {
      var filterData = allData.filter(function (item) {
        return item.sendSheet !== '' || item.sendMarks !== '' || item.sendCorrectMarks !== '';
      });
      data = filterData;
      setTableData(filterData);
    } else if (value === 'No') {
      var data1 = _utils.default.filterArray(allData, 'sendSheet', '');

      var data2 = _utils.default.filterArray(data1, 'sendMarks', '');

      var data3 = _utils.default.filterArray(data2, 'sendCorrectMarks', '');

      data = data3;
      setTableData(data3);
    } else {
      var details = _utils.default.filterArray(allData, 'sendSheet', '');

      data = allData;
      setTableData(details);
    }
  };

  return apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "Loading..."
  }) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24,
    xxl: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Filter",
    style: {
      height: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24,
    xxl: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    placeholder: "Search",
    style: {
      width: '90%'
    },
    prefix: /*#__PURE__*/_react.default.createElement(_icons.SearchOutlined, null),
    onChange: function onChange(e) {
      return onSearch(e);
    }
  })), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24,
    xxl: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Select, {
    defaultValue: 'All',
    style: {
      width: '90%'
    },
    onChange: FilterData
  }, /*#__PURE__*/_react.default.createElement(Option, {
    value: "All"
  }, "All"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "Yes"
  }, "Filled Data"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "No"
  }, "Not filled Data")))))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 24,
    xl: 24,
    xxl: 24,
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    style: {
      height: 120
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Progress, {
    status: filledData < 40 ? "exception" : "success",
    percent: filledData,
    format: function format(percent) {
      return "".concat(percent, " Audit");
    },
    type: "circle",
    width: 95
  }))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 24,
    xl: 24,
    xxl: 24
  }, /*#__PURE__*/_react.default.createElement(_DataDisplayWidget.default, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.UserSwitchOutlined, null),
    value: data.length,
    title: "Total Student",
    color: "cyan",
    size: "10",
    vertical: true,
    avatarSize: 30,
    style: {
      height: 120
    }
  }))), /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "RMCode : ".concat(RMCode),
    style: {
      backgroundColor: '#f5f5f5'
    }
  }, data.map(function (stu, index) {
    return /*#__PURE__*/_react.default.createElement(_antd.Card, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
      xxl: 24
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
      gutter: [8, 8]
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("h4", null, "Token no")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
      value: stu.Token_no,
      disabled: true
    }))))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
      gutter: [8, 8]
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("h4", null, "Student name")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
      value: stu.Student_name,
      disabled: true
    }))))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
      gutter: [8, 8]
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
      xxl: 24
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("h4", null, "Label")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, stu.Label ? /*#__PURE__*/_react.default.createElement(_antd.Button, {
      type: "link",
      onClick: function onClick() {
        return window.open(stu.Worksheet_link);
      }
    }, stu.Label) : "No Worksheet sent")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
      gutter: [8, 8]
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
      xxl: 24
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("h4", null, "Marks")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
      value: stu.Marks,
      disabled: true
    }))))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
      gutter: [8, 8]
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
      xxl: 24
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("h4", null, "\u0915\u094D\u092F\u093E \u0938\u0941\u092C\u0939 RM \u0928\u0947 \u0915\u093E\u092E \u092D\u0947\u091C\u093E ?")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      onFocus: function onFocus() {
        return panelChange(stu, "sendSheet");
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "m-1"
    }, stu.sendSheet === " " ? /*#__PURE__*/_react.default.createElement(_antd.Select, {
      style: {
        width: '100%'
      },
      onChange: selectOption,
      defaultValue: stu.sendSheet
    }, /*#__PURE__*/_react.default.createElement(Option, {
      value: "हाँ"
    }, "\u0939\u093E\u0901"), /*#__PURE__*/_react.default.createElement(Option, {
      value: "नहीं"
    }, "\u0928\u0939\u0940\u0902")) : /*#__PURE__*/_react.default.createElement(_antd.Select, {
      placeholder: "Option",
      style: {
        width: '100%'
      },
      onChange: selectOption
    }, /*#__PURE__*/_react.default.createElement(Option, {
      value: "हाँ"
    }, "\u0939\u093E\u0901"), /*#__PURE__*/_react.default.createElement(Option, {
      value: "नहीं"
    }, "\u0928\u0939\u0940\u0902")))))))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
      gutter: [8, 8]
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
      xxl: 24
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("h4", null, "\u0915\u094D\u092F\u093E RM \u0928\u0947 \u0935\u0930\u094D\u0915\u0936\u0940\u091F \u091A\u0947\u0915 \u0915\u0930\u0915\u0947 \u092E\u093E\u0930\u094D\u0915\u094D\u0938 \u092D\u0947\u091C\u0947\u0902?")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      onFocus: function onFocus() {
        return panelChange(stu, "sendMarks");
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "m-1"
    }, stu.sendMarks === "" ? /*#__PURE__*/_react.default.createElement(_antd.Select, {
      style: {
        width: '100%'
      },
      onChange: selectOption,
      defaultValue: stu.sendMarks
    }, /*#__PURE__*/_react.default.createElement(Option, {
      value: "हाँ"
    }, "\u0939\u093E\u0901"), /*#__PURE__*/_react.default.createElement(Option, {
      value: "नहीं"
    }, "\u0928\u0939\u0940\u0902")) : /*#__PURE__*/_react.default.createElement(_antd.Select, {
      placeholder: "Option",
      style: {
        width: '100%'
      },
      onChange: selectOption
    }, /*#__PURE__*/_react.default.createElement(Option, {
      value: "हाँ"
    }, "\u0939\u093E\u0901"), /*#__PURE__*/_react.default.createElement(Option, {
      value: "नहीं"
    }, "\u0928\u0939\u0940\u0902"), /*#__PURE__*/_react.default.createElement(Option, {
      value: "No रिस्पोंस फ़ोर्म"
    }, "No \u0930\u093F\u0938\u094D\u092A\u094B\u0902\u0938 \u095E\u094B\u0930\u094D\u092E")))))))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
      gutter: [8, 8]
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
      xxl: 24
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("h4", null, "\u0915\u094D\u092F\u093E RM \u0928\u0947 \u092E\u093E\u0930\u094D\u0915\u094D\u0938 \u0920\u0940\u0915 \u092D\u0947\u091C\u0947\u0902?")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      onFocus: function onFocus() {
        return panelChange(stu, "sendCorrectMarks");
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "m-1"
    }, stu.sendCorrectMarks === "" ? /*#__PURE__*/_react.default.createElement(_antd.Select, {
      style: {
        width: '100%'
      },
      onChange: selectOption,
      defaultValue: stu.sendCorrectMarks
    }, /*#__PURE__*/_react.default.createElement(Option, {
      value: "हाँ"
    }, "\u0939\u093E\u0901"), /*#__PURE__*/_react.default.createElement(Option, {
      value: "नहीं"
    }, "\u0928\u0939\u0940\u0902"), /*#__PURE__*/_react.default.createElement(Option, {
      value: "No रिस्पोंस फ़ोर्म"
    }, "No \u0930\u093F\u0938\u094D\u092A\u094B\u0902\u0938 \u095E\u094B\u0930\u094D\u092E")) : /*#__PURE__*/_react.default.createElement(_antd.Select, {
      placeholder: "Option",
      style: {
        width: '100%'
      },
      onChange: selectOption
    }, /*#__PURE__*/_react.default.createElement(Option, {
      value: "हाँ"
    }, "\u0939\u093E\u0901"), /*#__PURE__*/_react.default.createElement(Option, {
      value: "नहीं"
    }, "\u0928\u0939\u0940\u0902"), /*#__PURE__*/_react.default.createElement(Option, {
      value: "No रिस्पोंस फ़ोर्म"
    }, "No \u0930\u093F\u0938\u094D\u092A\u094B\u0902\u0938 \u095E\u094B\u0930\u094D\u092E")))))))))));
  })), /*#__PURE__*/_react.default.createElement(_antd.Card, null, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 8,
    sm: 8,
    md: 8,
    lg: 18,
    xl: 20,
    xxl: 20
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    onClick: back,
    className: "m-3",
    type: "link"
  }, "Go Back")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 16,
    sm: 16,
    md: 16,
    lg: 6,
    xl: 4,
    xxl: 4
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    className: "m-3",
    type: "primary",
    onClick: submitAllParent
  }, "Submit English Audit")))), /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    title: "Warning!!!",
    visible: warningBack,
    okText: "नहीं",
    cancelText: "हाँ",
    onOk: back,
    onCancel: cancel,
    type: "error"
  }, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement(_icons.ExclamationCircleOutlined, {
    style: {
      color: "orange"
    }
  }), " \u0915\u094D\u092F\u093E \u0906\u092A \u0935\u093E\u092A\u0938 \u091C\u093E\u0928\u093E \u091A\u093E\u0939\u0924\u0947 \u0939\u094B ? "), /*#__PURE__*/_react.default.createElement("p", null, "\u0905\u0917\u0930 \u0906\u092A \u0935\u093E\u092A\u0938 \u0917\u090F \u0924\u094B \u0906\u092A\u0915\u093E \u092D\u0930\u093E \u0939\u0941\u0906 \u0921\u093E\u091F\u093E \u0939\u091F \u091C\u093E\u090F\u0917\u093E \u0964")));
};

var _default = EnglishData;
exports.default = _default;